import React, { useState } from 'react';
import './Destinations.css';

const destinations = [
  {
    flag: '🇲🇾', country: 'Malaysia', tag: 'Local Hub',
    highlight: 'Top private universities',
    desc: 'World-class education at affordable costs. Home base for our agency with deep partnerships.',
    unis: ['HELP University', 'Sunway University', 'Taylor\'s University'],
    color: '#2196f3'
  },
  {
    flag: '🇨🇦', country: 'Canada', tag: 'Popular',
    highlight: 'PR-friendly pathways',
    desc: 'Excellent post-study work permits and immigration pathways. Safe and multicultural.',
    unis: ['University of Toronto', 'UBC', 'McGill University'],
    color: '#f44336'
  },
  {
    flag: '🇬🇧', country: 'United Kingdom', tag: 'Prestigious',
    highlight: 'World-renowned degrees',
    desc: 'Home to some of the world\'s oldest and most respected universities.',
    unis: ['University of London', 'University of Manchester', 'University of Leeds'],
    color: '#3f51b5'
  },
 
];

export default function Destinations() {
  const [activeIdx, setActiveIdx] = useState(null);

  return (
    <section className="destinations" id="destinations">
      <div className="section-inner">
        <div className="section-header">
          <span className="section-tag">Where We Send You</span>
          <h2 className="section-title">Study in <span className="gold-text">10+ Countries</span></h2>
          <p className="section-sub">From Asia to Europe to North America — we have established partnerships with universities across the globe.</p>
        </div>

        <div className="dest-grid">
          {destinations.map((d, i) => (
            <div
              className={`dest-card ${activeIdx === i ? 'active' : ''}`}
              key={i}
              style={{ '--card-accent': d.color }}
              onMouseEnter={() => setActiveIdx(i)}
              onMouseLeave={() => setActiveIdx(null)}
            >
              <div className="dest-card-top">
                <span className="dest-flag">{d.flag}</span>
                <span className="dest-tag">{d.tag}</span>
              </div>
              <h3 className="dest-country">{d.country}</h3>
              <p className="dest-highlight">{d.highlight}</p>
              <p className="dest-desc">{d.desc}</p>
              <div className="dest-unis">
                {d.unis.map((u, j) => <span key={j} className="uni-pill">{u}</span>)}
              </div>
              <a href="#contact" className="dest-cta">Learn More →</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
